
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/galleries/[index]",
      function () {
        return require("private-next-pages/inspiration/galleries/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/galleries/[index]"])
      });
    }
  